module.exports = __webpack_public_path__ + "2259104847cce9410871fafabe74ba84.svg";